var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',[_c('InfoEmployee',{attrs:{"user":_vm.detailUser,"loadingItem":_vm.loadingTable,"updateEmployeeOnView":_vm.updateEmployeeOnView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }